import React, {  useState, useEffect } from 'react';
import Navigationbar from "../Navigationbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {Button, Card, Table} from "react-bootstrap";
import {useAuth} from "../../authprovider";
import AddVideoModal from "./AddVideoModal";
import { useTranslation } from 'react-i18next';


export default function VideosPage() {
    const auth = useAuth();
    const [modalAddVideo, setModalAddVideo] = useState({show:false})
    const [videos, setVideos] = useState(
        undefined
    );
    const { t } = useTranslation();

    useEffect(()=>{
        if(videos!==undefined)
            return;

        auth.videos.get(response=>{
            const {success, error, content} = response;

            if(success === true){
                setVideos(content)
            } else {
                alert(error)
                console.log(error);
            }

        })
    })

    const showAddVideoModal = ()=>{
        setModalAddVideo({show:true})
    }

    const onHideAddVieoModal = (result)=>{

        if(result)
            setVideos([...videos, result]);

        setModalAddVideo({show:false})
    }

    const deleteVideo = (id)=>{
        const video = videos.find((val)=>val.id === id);

        if(!video)
            return;

        if(window.confirm(t('videos.confirmDeleteVideo', { name: video.name }))){

            auth.videos.delete(id, response=>{
                const {success, error} = response;

                if(success === true){
                    setVideos(videos.filter((vid)=>vid.id !== id))
                } else {
                    alert(error)
                    console.log(error);
                }
            })

        }
    }


    return (
        <>
            <Navigationbar/>
            <div className={"container"}>
                <Card className={"m-2 p-2"} key={"data"}>
                    <div className={"mt-2"}>
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>{t('videos.tableHeaderLp')}</th>
                                <th>{t('videos.tableHeaderName')}</th>
                                <th>{t('videos.tableHeaderCategory')}</th>
                                <th>{t('videos.tableHeaderActions')}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                videos && videos.map((video, lp)=>{
                                    return (
                                        <tr key={video.id}>
                                            <td>{lp+1}</td>
                                            <td>{video.name}</td>
                                            <td>{video.category}</td>
                                            <td>
                                                <Button name={"Usuń"} className={"ms-2"} title={t('videos.delete')} variant={"outline-primary"} onClick={()=>deleteVideo(video.id)} ><FontAwesomeIcon icon={faTrashCan} /></Button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </Table>
                        <Button name={"Dodaj"} className="me-4" style={{position:"fixed", bottom:"10px", right:"10px"}} variant="warning " onClick={showAddVideoModal} >
                            {t('videos.add')}
                        </Button>
                        <AddVideoModal show={modalAddVideo.show} onHide={onHideAddVieoModal} />
                    </div>
                </Card>
            </div>

        </>
    )
}